export const ROUTE = {
  HOMEPAGE: '/',
  RSS: '/rss',
  TERMS_OF_USE: '/terms-of-use',
  PRIVACY: '/privacy',
  NEWSLETTER: '/SignUp',
  CONTACT_US: '/contact-us',
  FORGOT_PASSWORD: '/forgot-password',
  IL_DIR_HP: '/ForexBrokers',
  TERMS: '/terms',
  TERMS_SEARCH_RESULTS: '/terms/search-results/',
  TAG_SEARCH_RESULTS: '/tag/search-results/',
  ABOUT: '/about',
  ECONOMIC_CALENDAR: '/EconomicCalendar',
  EDUCATION: '/Education',
  SEARCH_RESULTS: '/search-results/',
  BECOME_AN_AUTHOR: '/become-an-author/',
  COOKIES: '/cookies/',
  LIVE_CHARTS: '/LiveCharts',
  LIVE_QUOTES: '/LiveQuotes',
  STOCKS: '/stocks/',
  PREMIUM: '/premium/',
  LIVE_FEED: '/live-feed/',
  PERSONAL_PROFILE: '/profile',
  PERSONAL_PROFILE_MY_COMPANIES: '/profile/my-companies',
  PERSONAL_PROFILE_ADD_COMPANY: '/profile/my-companies/add-company',
  PERSONAL_PROFILE_MY_CONTRIBUTIONS: '/profile/my-contributions',
  PERSONAL_PROFILE_FOLLOWING_PREFERENCES: '/profile/following-preferences',
  COMPANY_COMPARE: '/company-compare' // TODO IL DIRECTORY - Akis - ROUTE IS NOT FINAL
}

export const FM_DIR_ROUTE = {
  SEARCH_RESULTS: '/search-results',
  COMPANY_NEWS: '/news-and-articles'
}

export const FM_ROUTE = {
  HOMEPAGE: '/',
  ALL_NEWS: '/all-news',
  INTELLIGENCE: '/intelligence',
  INTELLIGENCE_PRODUCTS: '/intelligence/products',
  INTELLIGENCE_PRODUCTS_ANNUAL: '/intelligence/products/annual',
  INTELLIGENCE_PRODUCTS_QIR: '/intelligence/products/qir',
  EVENTS: '/events',
  INTERVIEW: '/executives/interviews',
  FORGOT_PASSWORD: '/forgot-password',
  TERMS: '/terms',
  SEARCH_RESULTS: '/search-results',
  PERSONAL_PROFILE_MY_CONTRIBUTIONS: '/profile/my-contributions'
}

export const ROUTE_NAME = {
  HOMEPAGE: 'index',
  LIVE_FEED: 'live-feed',
  ABOUT: 'about',
  CATEGORY: 'category',
  CATEGORY_ARTICLE: 'category-article',
  CATEGORY_ARTICLE_AMP: 'category-article-amp',
  CATEGORY_ARTICLE_GIBBERISH: 'category-article-gibberish',
  CATEGORY_MIGRATED_ARTICLE_GIBBERISH: 'category-article-migrated-gibberish',
  SHARED_COMPONENTS: 'shared-components',
  RSS: 'rss',
  TERMS_OF_USE: 'terms-of-use',
  PRIVACY: 'privacy',
  COOKIES: 'cookies',
  CONTACT_US: 'contact-us',
  TERMS: 'terms',
  TERMS_LETTER: 'terms-letter',
  TERMS_LETTER_TERM: 'terms-letter-term',
  TERMS_SEARCH_RESULTS: 'terms-search-results',
  NEWSLETTER: 'SignUp',
  SEARCH_RESULTS: 'search-results',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  AUTHOR: 'author',
  AUTHOR_AUTHOR: 'author-author',
  TAG: 'Tag',
  TAG_TAG: 'Tag-tag',
  TAG_SEARCH_RESULTS: 'Tag-search-results',
  FOREX_BROKERS: 'ForexBrokers',
  BROKERS: 'Brokers',
  DIRECTORY_COMPANY: 'Brokers-company',
  DIRECTORY_COMPANY_REVIEW: 'Brokers-company-review',
  BECOME_AN_AUTHOR: 'become-an-author',
  EDUCATION: 'Education',
  ECONOMIC_CALENDAR: 'EconomicCalendar',
  LIVE_CHARTS: 'LiveCharts',
  LIVE_QUOTES: 'LiveQuotes',
  LIVE_QUOTES_ASSET: 'LiveQuotes-asset',
  SESSION_WRAPS: 'SessionWraps',
  REACTIVATION: 'reactivation',
  STOCKS: 'stocks',
  STOCKS_STOCK: 'stocks-stock',
  PREMIUM: 'premium',
  PERSONAL_PROFILE: 'profile',
  PERSONAL_PROFILE_MY_CONTRIBUTIONS: 'profile-my-contributions',
  PERSONAL_PROFILE_ADD_POST: 'profile-my-contributions-edit',
  PERSONAL_PROFILE_EDIT_POST: 'profile-my-contributions-edit-articleSlug',
  PERSONAL_PROFILE_MY_COMPANIES: 'profile-my-companies',
  PERSONAL_PROFILE_ADD_COMPANY: 'profile-my-companies-add-company',
  PERSONAL_PROFILE_EDIT_COMPANY: 'profile-my-companies-category-company-edit',
  PERSONAL_PROFILE_COMPANY_NEWS: 'profile-my-companies-category-company-news',
  PERSONAL_PROFILE_ADD_COMPANY_NEWS:
    'profile-my-companies-category-company-news-edit',
  PERSONAL_PROFILE_EDIT_COMPANY_NEWS:
    'profile-my-companies-category-company-news-article-edit',
  PERSONAL_PROFILE_COMPANY_VIDEOS:
    'profile-my-companies-category-company-videos',
  PERSONAL_PROFILE_ADD_COMPANY_VIDEO:
    'profile-my-companies-category-company-videos-edit',
  PERSONAL_PROFILE_EDIT_COMPANY_VIDEO:
    'profile-my-companies-category-company-videos-video-edit',
  PERSONAL_PROFILE_FOLLOWING_PREFERENCES: 'profile-following-preferences',
  COMPANY_COMPARE: 'company-compare' // TODO IL DIRECTORY - Akis - ROUTE IS NOT FINAL
}

export const PERSONAL_AREA_ROUTES = [
  ROUTE_NAME.PERSONAL_PROFILE,
  ROUTE_NAME.PERSONAL_PROFILE_MY_CONTRIBUTIONS,
  ROUTE_NAME.PERSONAL_PROFILE_ADD_POST,
  ROUTE_NAME.PERSONAL_PROFILE_EDIT_POST,
  ROUTE_NAME.PERSONAL_PROFILE_MY_COMPANIES,
  ROUTE_NAME.PERSONAL_PROFILE_ADD_COMPANY,
  ROUTE_NAME.PERSONAL_PROFILE_EDIT_COMPANY,
  ROUTE_NAME.PERSONAL_PROFILE_COMPANY_NEWS,
  ROUTE_NAME.PERSONAL_PROFILE_ADD_COMPANY_NEWS,
  ROUTE_NAME.PERSONAL_PROFILE_EDIT_COMPANY_NEWS,
  ROUTE_NAME.PERSONAL_PROFILE_COMPANY_VIDEOS,
  ROUTE_NAME.PERSONAL_PROFILE_ADD_COMPANY_VIDEO,
  ROUTE_NAME.PERSONAL_PROFILE_EDIT_COMPANY_VIDEO,
  ROUTE_NAME.PERSONAL_PROFILE_FOLLOWING_PREFERENCES
]

export const AMP_PAGES = [ROUTE_NAME.CATEGORY_ARTICLE_AMP]

export const IL_DIR_ROUTE_NAMES = [
  ROUTE_NAME.FOREX_BROKERS,
  ROUTE_NAME.DIRECTORY_COMPANY
]

export const GUARDED_ROUTES = [
  ...PERSONAL_AREA_ROUTES,
  ROUTE_NAME.BECOME_AN_AUTHOR
]
